import { globalTheme } from 'srs.sharedcomponents/lib/esm/styles/config';

const gmThemeColor = '#333333';
export const customTheme = {
    ...globalTheme,
    colors: {
        primary: gmThemeColor,
    },
};
